import React from 'react';
import '../template-file-css/document-file-template.css';


export const TCC_AdultIntakePacket = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='TCC_AdultIntakePacket' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center><h3>Texas Care!</h3></center>
                </p>

                <p className='small w-750'>
                    <center>15603 Kuykendahl Rd <br />
                        Houston, TX 77090 <br /> (888) 988-6329</center>
                </p>

                <p className='w-750'>
                    <center><h4>Welcome to Texas Care!</h4></center>
                </p>

                <p className='w-750'>
                    We hope that we can be of assistance and thank you for choosing Texas Care for your mental health needs.
                </p>

                <p className='w-750'>
                    {`Texas Care offers a variety of services online and in person: psychotherapy (individual, family, couples), community based rehabilitative services such as skills training and development, psychosocial rehabilitation, targeted case management, crisis intervention, and medication management training & support.`}
                </p>

                <p className='w-750'>
                    {`In an effort to help you better utilize your treatment and understand Texas Care's procedures, we have created this new client packet of information and guidelines. Your cooperation with these guidelines will assist us in providing care as quickly and efficiently as possible.`}
                </p>

                <p className='w-750'>
                    Your treatment will begin following an assessment process which will include a Comprehensive Mental Health Assessment and may include a Psychiatric Evaluation. Information from the assessments and your input will help us determine the services that you need.
                </p>

                <p className='w-750'>
                    Treatment is a collaborative process between you and your service providers. We are counting on you to partner with us to outline achievable goals and objectives to meet your treatment needs.
                </p>

                <p className='w-750'>
                    {`Crisis situations can occur anytime day or night. In the event that you experience a crisis outside our normal business operating hours, and you are receiving Community Based Rehabilitative Services, contact your assigned Qualified Mental Health Professional and/or call 1-888-988-6329 and one of our Texas Care specialists will help you problem solve, advocate, or make referrals as appropriate. If you are in danger, in danger of harming yourself or others, call 911 or go to your nearest emergency room.`}
                </p>

                <p className='w-750'>
                    {`Regular attendance at appointments is necessary for effective treatment. Please attend all appointments consistently as scheduled. If you must miss an appointment, please let us know 24 hours in advance to avoid fee charges and/or being discharged from Texas Care Center.`}
                </p>

                <p className='w-750'>
                    {`All requested paperwork/forms must be completed prior to services being rendered. Texas Care professionals do not provide depositions, court evaluations or serve as expert witnesses for people who do not utilize the treatment and recovery services of Texas Care.`}
                </p>

                <p className='w-750'>
                    {`In the event that agency personnel are ordered to provide any of the above, there will be a charge for these services.`}
                </p>

                <p className='w-100'>Sincerely,</p>

                <p className='w-100'>Texas Care</p>

                <p className='w-750'>
                    <center><h4>CLIENT RIGHTS AND RESPONSIBILITIES</h4></center>
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            {`The right to a humane treatment or habilitation environment that affords reasonable protection from harm, exploitation, and coercion.`}
                        </li>
                        <li>
                            {`The right to participate in providing input to your program and an individualized care plan specific to your strengths, needs, abilities, and preferences.`}
                        </li>
                        <li>
                            The right to have access to their own client records and to obtain necessary copies when needed.
                        </li>
                        <li>
                            {`The right to refuse services, unless a physician or licensed professional feels that refusal is not in your best interest due to yours or another's safety.`}
                        </li>
                        <li>
                            {`The right to converse privately, have convenient and reasonable access to the telephone and mail, and to see visitors, unless denial is necessary for treatment and the reasons are documented in the treatment plan.`}
                        </li>
                        <li>
                            The right to prompt and confidential services regardless of your funding source.
                        </li>
                        <li>
                            The right to be fully informed of the charges for treatment.
                        </li>
                        <li>
                            The right to receive information in a language you understand and to ask questions and obtain answers about any information for which you need clarification.
                        </li>
                        <li>
                            {`The right to remain free of physical restraints or time-out procedures unless such measures are required for providing effective treatment or protecting the safety of you or another.`}
                        </li>
                        <li>
                            {`The right to be free from any type of abuse, verbal, emotional, physical, financial, or sexual; to be free from neglect, humiliation, or retaliation.`}
                        </li>
                        <li>
                            The right to cancel an appointment with the understanding it is my responsibility to reschedule.
                        </li>
                        <li>
                            {`The right to be promptly informed of any changes, benefits, or risks in the plan of treatment in sufficient time to make decisions regarding my treatment or services.`}
                        </li>
                        <li>
                            {`The right to terminate treatment voluntarily or to be terminated prior to my discharge date for violation of the expectations, treatment, or responsibilities.`}
                        </li>
                        <li>
                            The right to know names and titles of all those involved in treatment and service planning and implementation.
                        </li>
                        <li>
                            The right to refuse psychotropic medication recommendations.
                        </li>
                        <li>
                            The right to have and retain personal property which does not jeopardize the safety of the client or other clients or staff and have such property treated with respect.
                        </li>
                        <li>
                            {`The right to file a complaint or to present a grievance to the Compliance Officer without fear of retaliation, including but not limited to service termination, if you feel any of your rights have been violated.`}
                        </li>
                        <li>
                            The right to receive a written notice of the address and telephone number of that state licensing authority.
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <center><h4>Expectation of Consumers and Families Participating in Services</h4></center>
                </p>

                <p className='w-750'>
                    {`Services provided by Texas Care are designed to meet the needs of consumers and families. Some services such as the Community Based Services (Skills Training and Development, Targeted Case Management) are intended to be a program for both the child and the family that requires a commitment to services and full participation from both the child and the parent/guardian. As a participant of these services, you will be required to interact and participate with several team members. The child, and possibly the parent/guardian, may be transitioned to supportive, less intensive community service programs when indicated. The treatment team will work with you to assure you are receiving that level of service to meet your needs. Interactions with those providing services may include direct service or referrals for:`}
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            Case Management Services to gain community resources and referrals
                        </li>
                        <li>
                            {`Psychosocial Rehabilitation Services to gain psychological support, vocational and independent living skills, skills to help improve relationships, education/employment skills, and many other skills necessary to improve functioning and reduce symptoms of a mental illness`}
                        </li>
                        <li>
                            Counseling
                        </li>
                        <li>
                            Family Therapy
                        </li>
                        <li>
                            Psychological Evaluation and/or Psychiatric Evaluation
                        </li>
                        <li>
                            Crisis Intervention
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>Note:</b>{`There is a three (3) strikes policy. We want to empower consumers and families to participate in treatment and encourage responsibility as part of emotional health. We understand cancellations and emergencies do occur. However, we want consumers and families to call to cancel appointments, to be home during scheduled appointments, and to maintain appointments with Texas Care mental health professionals If there have been three occurrences of noncompliance, this may lead to early discharge from Texas Care.`}
                </p>

                <p className='w-750'>
                    <center><h4>CONSENT/AUTHORIZATION FOR TREATMENT & SERVICES</h4></center>
                </p>

                <p className='w-750'>
                    {`I am requesting services from Texas Care for the above-named consumer. I apply for and consent to receive treatment provided by Texas Care and its staff, employees, or designees. I authorize the mental and physical health care services deemed necessary or advisable by my caregivers to address my needs.`}
                </p>

                <p className='w-750'>
                    {`When receiving Mental Health Rehabilitation and Targeted Case Management services, I understand the consumer’s treatment team may consist of a licensed mental health professional, a master's level therapist, Qualified Mental Health Professionals (QMHP-CS), a bachelor’s level mental health professional, a Case Manager, in addition to clinical support staff. Once admitted to the program, the consumer's status and progress will be reviewed every ninety (90) days.`}
                </p>

                <p className='w-750'>
                    {`An Individualized Treatment/Recovery Plan will be developed which contains goals and desired outcomes that can be expected to be achieved in order to be able to move to less intensive support services. I have had input to these goals and agree to work towards the goals and objectives as established in the treatment plan.`}
                </p>

                <p className='w-750'>
                    {`Benefits of services may include improved behavior in children, improved family cohesion and communication, and acquisition of healthy coping skills. I understand the risks any time an individual or family participates in counseling/mental health services may include disclosure of information that may have not been previously discussed and feelings surfacing that have not been previously expressed which might be stressful. I understand counseling and mental health services can provide skills to help me understand and cope with these feelings, make healthier decisions and feel better emotionally.`}
                </p>

                <p className='w-750'>
                    {`I can receive concurrent services while receiving services at Texas Care, but I agree to let my mental health professional know so that duplication of services does not occur.`}
                </p>

                <p className='w-750'>
                    {`I understand the consumer must have active Medicaid to receive Community Based Services such as Mental Health Rehabilitation and Targeted Case Management services and be enrolled with a managed care organization Texas Care currently accepts and is enrolled with. I agree to provide accurate and complete information to Texas Care for billing of the consumer's treatment and agree to update this information as changes occur. I understand that I will not receive a bill from Texas Care, Medicaid, or the Managed Care organization. However, I consent to allow to bill Medicaid, or one of their managed care organizations (MCOs) for services provided to the consumer. I authorize exchange of any information between and Medicaid or one of their managed care organizations for the purpose of providing accurate, thorough and quality services.`}
                </p>

                <p className='w-750'>
                    <center><h4>Notice of Privacy Practices</h4></center>
                </p>

                <p className='w-750'>
                    THIS NOTICE DESCRIBES HOW HEALTH INFORMATION MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.
                </p>

                <p className='w-750'>
                    <b>I. MY PLEDGE REGARDING HEALTH INFORMATION:</b> <br/> 
                    {`I understand that health information about you and your health care is personal. I am committed to protecting health information about you. I create a record of the care and services you receive from me. I need this record to provide you with quality care and to comply with certain legal requirements. This notice applies to all of the records of your care generated by this mental health care practice. This notice will tell you about the ways in which I may use and disclose health information about you. I also describe your rights to the health information I keep about you, and describe certain obligations I have regarding the use and disclosure of your health information. I am required by law to:`}
                    <ul>
                        <li>
                            {`Make sure that protected health information (“PHI”) that identifies you is kept private.`}
                        </li>
                        <li>
                            Give you this notice of my legal duties and privacy practices with respect to health information.
                        </li>
                        <li>
                            Follow the terms of the notice that is currently in effect.
                        </li>
                        <li>
                            {`I can change the terms of this Notice, and such changes will apply to all information I have about you.`}
                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    {`The new Notice will be available upon request, in my office, and on my website.`}
                </p>

                <p className='w-750'>
                    <b>II. HOW I MAY USE AND DISCLOSE HEALTH INFORMATION ABOUT YOU:</b>
                </p>

                <p className='w-750'>
                    {`The following categories describe different ways that I use and disclose health information. For each category of uses or disclosures I will explain what I mean and try to give some examples. Not every use or disclosure in a category will be listed. However, all of the ways I am permitted to use and disclose information will fall within one of the categories.`}
                </p>

                <p className='w-750'>
                    {`For Treatment Payment, or Health Care Operations: Federal privacy rules and regulations allow health care providers who have direct treatment relationship with the client to use or disclose the client’s personal health information without the client’s written authorization, to carry out the health care provider’s own treatment, payment or health care operations. I may also disclose your protected health information for the treatment activities of any health care provider. This too can be done without your written authorization. For example, if a clinician were to consult with another licensed health care provider about your condition, we would be permitted to use and disclose your person health information, which is otherwise confidential, in order to assist the clinician in diagnosis and treatment of your mental health condition.`}
                </p>

                <p className='w-750'>
                    {`Disclosures for treatment purposes are not limited to the minimum necessary standard. Because therapists and other health care providers need access to the full record and/or full and complete information in order to provide quality care. The word “treatment” includes, among other things, the coordination and management of health care providers with a third party, consultations between health care providers and referrals of a patient for health care from one health care provider to another.`}
                </p>

                <p className='w-750'>
                    {`Lawsuits and Disputes: If you are involved in a lawsuit, I may disclose health information in response to a court or administrative order. I may also disclose health information about your child in response to a subpoena, discovery`}
                </p>

                <p className='w-750'>
                    <b>III. CERTAIN USES AND DISCLOSURES REQUIRE YOUR AUTHORIZATION:</b>
                </p>

                <p className='w-750'>
                    <b>1.</b> {`Psychotherapy Notes. I do keep “psychotherapy notes” as that term is defined in 45 CFR § 164.501, 
                   and any use or disclosure of such notes requires your Authorization unless the use or disclosure is:`}
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            For my use in treating you.
                        </li>
                        <li>
                            {`For my use in training or supervising mental health practitioners to help them improve their skills in
                            group, joint, family, or individual counseling or therapy.`}
                        </li>
                        <li>
                            For my use in defending myself in legal proceedings instituted by you.
                        </li>
                        <li>
                            For use by the Secretary of Health and Human Services to investigate my compliance with HIPAA.
                        </li>
                        <li>
                            Required by law and the use or disclosure is limited to the requirements of such law.
                        </li>
                        <li>
                            Required by law for certain health oversight activities pertaining to the originator of the
                            psychotherapy notes.
                        </li>
                        <li>
                            Required by a coroner who is performing duties authorized by law.
                        </li>
                        <li>
                            Required to help avert a serious threat to the health and safety of others.
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>2.</b> {`Marketing Purposes. As a psychotherapist, I will not use or disclose your PHI for marketing purposes.`}
                </p>

                <p className='w-750'>
                    <b>3.</b> {`Sale of PHI. As a psychotherapist, I will not sell your PHI in the regular course of my business.`}
                </p>

                <p className='w-750'>
                    <b>IV. CERTAIN USES AND DISCLOSURES DO NOT REQUIRE YOUR AUTHORIZATION. Subject to certain</b>
                </p>

                <p className='w-750'>
                    limitations in the law, I can use and disclose your PHI without your Authorization for the following reasons:

                    <ol>
                        <li>
                            When disclosure is required by state or federal law, and the use or disclosure complies with and is limited to the relevant requirements of such law.
                        </li>
                        <li>
                            {`For public health activities, including reporting suspected child, elder, or dependent adult abuse, or preventing or reducing a serious threat to anyone’s health or safety.`}
                        </li>
                        <li>
                            {`For health oversight activities, including audits and investigations.`}
                        </li>
                        <li>
                            {`For judicial and administrative proceedings, including responding to a court or administrative order, although my preference is to obtain an Authorization from you before doing so.`}
                        </li>
                        <li>
                            {`For law enforcement purposes, including reporting crimes occurring on my premises.`}
                        </li>
                        <li>
                            To coroners or medical examiners, when such individuals are performing duties authorized by law.
                        </li>
                        <li>
                            For research purposes, including studying and comparing the mental health of patients who received one form of therapy versus those who received another form of therapy for the same condition.
                        </li>
                        <li>
                            {`Specialized government functions, including, ensuring the proper execution of military missions; protecting the President of the United States; conducting intelligence or counter-intelligence operations; or, helping to ensure the safety of those working within or housed in correctional institutions.`}
                        </li>
                        <li>
                            {`For workers' compensation purposes. Although my preference is to obtain an Authorization from you, I may provide your PHI in order to comply with workers' compensation laws.`}
                        </li>
                        <li>
                            Appointment reminders and health related benefits or services. I may use and disclose your PHI to contact you to remind you that you have an appointment with me. I may also use and disclose your PHI to tell you about treatment alternatives, or other health care services or benefits that I offer.
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>V. CERTAIN USES AND DISCLOSURES REQUIRE YOU TO HAVE THE OPPORTUNITY TO OBJECT.</b>
                    <ol>
                        <li>
                            {`Disclosures to family, friends, or others. I may provide your PHI to a family member, friend, or other person that you indicate is involved in your care or the payment for your health care, unless you object in whole or in part. The opportunity to consent may be obtained retroactively in emergency situations.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>VI. YOU HAVE THE FOLLOWING RIGHTS WITH RESPECT TO YOUR PHI:</b>
                    <ol>
                        <li>
                            {`The Right to Request Limits on Uses and Disclosures of Your PHI. You have the right to ask me not to use or disclose certain PHI for treatment, payment, or health care operations purposes. I am not required to agree to your request, and I may say “no” if I believe it would affect your health care.`}
                        </li>
                        <li>
                            {`The Right to Request Restrictions for Out-of-Pocket Expenses Paid for In Full. You have the right to request restrictions on disclosures of your PHI to health plans for payment or health care operations purposes if the PHI pertains solely to a health care item or a health care service that you have paid for out-of-pocket in full.`}
                        </li>
                        <li>
                            {`The Right to Choose How I Send PHI to You. You have the right to ask me to contact you in a specific way (for example, home or office phone) or to send mail to a different address, and I will agree to all reasonable requests.`}
                        </li>
                        <li>
                            {`The Right to See and Get Copies of Your PHI. Other than “psychotherapy notes,” you have the right to get an electronic or paper copy of your medical record and other information that I have about you. I will provide you with a copy of your record, or a summary of it, if you agree to receive a summary, within 30 days of receiving your written request, and I may charge a reasonable, cost based fee for doing so.`}
                        </li>
                        <li>
                            {`The Right to Get a List of the Disclosures I Have Made. You have the right to request a list of instances in which I have disclosed your PHI for purposes other than treatment, payment, or health care operations, or for which you provided me with an Authorization. I will respond to your request for an accounting of disclosures within 60 days of receiving your request. The list I will give you will include disclosures made in the last six years unless you request a shorter time. I will provide the list to you at no charge, but if you make more than one request in the same year, I will charge you a reasonable cost based fee for each additional request.`}
                        </li>
                        <li>
                            {`The Right to Correct or Update Your PHI. If you believe that there is a mistake in your PHI, or that a piece of important information is missing from your PHI, you have the right to request that I correct the existing information or add the missing information. I may say “no” to your request, but I will tell you why in writing within 60 days of receiving your request.`}
                        </li>
                        <li>
                            {`The Right to Get a Paper or Electronic Copy of this Notice. You have the right get a paper copy of this Notice, and you have the right to get a copy of this notice by e-mail. And, even if you have agreed to receive this Notice via e-mail, you also have the right to request a paper copy of it.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b> ACKNOWLEDGEMENT OF RECEIPT OF PRIVACY NOTICE </b>
                </p>

                <p className='w-750'>
                    {`Under the Health Insurance Portability and Accountability Act of 1996 (HIPAA), you have certain rights regarding the use and disclosure of your protected health information. By signing this document, you are acknowledging that you have received a copy of HIPAA Notice of Privacy Practices.`}
                </p>

                <p className='w-750'>
                    <center><h4>Information and Informed Consent for Telemental/Telehealth Treatment</h4></center>
                </p>

                <p className='w-750'>
                    {`Telemental health is live two - way audio and video electronic communications that allows mental health professionals and clients to meet outside of a physical office setting.`}
                </p>

                <p className='w-750'>
                    Client Understanding
                </p>

                <p className='w-750'>
                    I understand that telemental health services are completely voluntary and that I can withdraw this consent at any time.
                </p>

                <p className='w-750'>
                    I understand that none of the telemental health sessions will be recorded or photographed.
                </p>

                <p className='w-750'>
                    I agree not to make or allow audio or video recordings of any portion of the sessions.
                </p>

                <p className='w-750'>
                    {`I understand that the laws that protect privacy and the confidentiality of client information also apply to telemental health, and that no information obtained in the use of telemental health that identifies me will be disclosed to other entities without my consent.`}
                </p>

                <p className='w-750'>
                    {`I understand that telemental health is performed over a secure communication system that is almost impossible for anyone else to access. I understand that any internet based communication is not 100 % guaranteed to be secure.`}
                </p>

                <p className='w-750'>
                    I agree that the mental health professional and practice will not be held responsible if any outside party gains access to my personal information by bypassing the security measures of the communication system.
                </p>

                <p className='w-750'>
                    {`I understand there are potential risks to this technology, including interruptions, unauthorized access, and technical difficulties.`}
                </p>

                <p className='w-750'>
                    I understand that I or my mental health professional may discontinue the telemental sessions at any time if it is felt that the video technology is not adequate for the situation.
                </p>

                <p className='w-750'>
                    {`I understand that if there is an emergency during a telemental health session, then my therapist may call emergency services and/ or my emergency contact.`}
                </p>

                <p className='w-750'>
                    I understand that this form is signed in addition to the Notice of Privacy Practices and Consent to Treatment and that all office policies and procedures apply to telemental health services.
                </p>

                <p className='w-750'>
                    {`I understand that if the video conferencing connection drops while I am in a session, I will have an additional phone line available to contact my therapist, or I will make additional plans with my therapist ahead of time for re - contact.`}
                </p>

                <p className='w-750'>
                    {`I understand a “no show” or late fee will be charged if I miss an appointment or do not cancel within 24 hours of scheduled appointment. I understand credit card or other form of payment will be established before the first session.`}
                </p>

                <p className='w-750'>
                    I understand my mental health professional will advise me about what telemental health platform to use and she will establish a video conference session
                </p>

                <p className='w-750'>
                    <center><h4>Legal Request - Court Proceeding</h4></center>
                </p>

                <p className='w-750'>
                    {`If I, my legal counsel, or an adversarial counsel subpoenas any mental health professional or staff member from Texas Care to appear on my behalf, in a deposition or any court proceeding, I agree to pay Texas Care $1500.00 per day to appear in court cases within the same county of the mental health professional or staff member primary office location payable to Texas Care.`}
                </p>

                <p className='w-750'>
                    {`If the mental health professional or staff member is required to travel outside their county or stay overnight, an additional full day rate will be charged. A half-day rate may be possible in the event of a pre-scheduled online court appearance.`}
                </p>

                <p className='w-750'>
                    I also understand that the mental health professional or staff member will require a subpoena to appear. An email subpoena is acceptable.
                </p>

                <p className='w-750'>
                    {`I also understand that the court appearance fee is due 72 hours in advance of my appearance, and if that fee is not paid as required, the mental health professional or staff member will seek legal representation to file a motion to quash the subpoena.`}
                </p>

                <p className='w-750'>
                    {`If the court appearance is canceled with a minimum of 48 hours advance notice, $1000.00 may be refunded to you. This is not a guarantee. Despite cancellation, I understand that payment processing fees, the mental health professional's or staff member's legal fees, time spent in court preparation is an expense.`}
                </p>

                <p className='w-750'>
                    {`If I or my legal counsel requests a copy of the client file, session notes, treatment summaries or session attendance documentation on my behalf, I agree to pay all reasonable copying and or postage costs. Clients may pick up the documents or pay to have the documents mailed to them. All payments must be processed before the documents are presented.`}
                </p>

                <p className='w-750'>
                    {`Texas Care mental health professionals and staff members are not expert witnesses nor custody evaluators. We cannot give legal advice so we strongly urge clients to discuss with their lawyers the perceived need for counselor’s documentation or court testimony, and the subsequent financial burden it may cause the client.`}
                </p>

                <p className='w-750'>
                    {`By signing below, you are acknowledging that you have received the Legal Request-Court Proceedings document, are aware of this policy, and agree.`}
                </p>

                <p className='w-750'>
                    <center><h4>CRISIS/SAFETY PLAN </h4></center>
                </p>

                <p className='w-750'>
                    <b>Natural Supports and Agencies Involved:</b>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Name</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Contact Name/Title</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtContactName_1' name='txtContactName_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtContactName_2' name='txtContactName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtContactName_3' name='txtContactName_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_3' name='txtPhoneNumber_3' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Crisis Triggers</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Describe Needed Response</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Responsible Person/s<span className='small'>(name/phone)</span></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Home</td>
                        <td className='w-250'>Client's Response</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_1' name='txtCrisisTriggers_1' placeholder='1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_1' name='txtDescribe_1' placeholder='1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_1' name='txtResponsiblePerson_1' placeholder='1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_2' name='txtCrisisTriggers_2' placeholder='2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_2' name='txtDescribe_2' placeholder='2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_2' name='txtResponsiblePerson_2' placeholder='1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_3' name='txtCrisisTriggers_3' placeholder='3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_3' name='txtDescribe_3' placeholder='3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_3' name='txtResponsiblePerson_3' placeholder='3' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>School</td>
                        <td className='w-250'>Client's Response</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_4' name='txtCrisisTriggers_4' placeholder='1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_4' name='txtDescribe_4' placeholder='1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_4' name='txtResponsiblePerson_4' placeholder='1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_5' name='txtCrisisTriggers_5' placeholder='2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_5' name='txtDescribe_5' placeholder='2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_5' name='txtResponsiblePerson_5' placeholder='1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_6' name='txtCrisisTriggers_6' placeholder='3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_6' name='txtDescribe_6' placeholder='3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_6' name='txtResponsiblePerson_6' placeholder='3' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>Community</td>
                        <td className='w-250'>Client's Response</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_7' name='txtCrisisTriggers_7' placeholder='1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_7' name='txtDescribe_7' placeholder='1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_7' name='txtResponsiblePerson_7' placeholder='1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_8' name='txtCrisisTriggers_8' placeholder='2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_8' name='txtDescribe_8' placeholder='2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_8' name='txtResponsiblePerson_8' placeholder='1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCrisisTriggers_9' name='txtCrisisTriggers_9' placeholder='3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDescribe_9' name='txtDescribe_9' placeholder='3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtResponsiblePerson_9' name='txtResponsiblePerson_9' placeholder='3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>Crisis/Safety Plan Agreement</b>
                </p>

                <p className='w-750'>
                    I &nbsp;
                    <input type='text' id='txtParent' name='txtParent' className='add-only w-200 custom-add-only' /> &nbsp;
                    parent/guardian of &nbsp; <input type='text' id='txtParticipated' name='txtParticipated' className='add-only w-200 custom-add-only' /> &nbsp;
                    have participated in the development of the crisis/safety plan and we have partnered with in the development of these crisis/safety plan on my choices, preferences, and desired outcomes.
                </p>

                <p className='w-750'>
                    <center><h4>Acknowledgement of Receipt Form</h4></center>
                </p>

                <p className='w-750'>
                Client Handbook
                </p>

                <p className='w-750'>
                I acknowledge that I have received a copy of the Client Handbook, which covers the following topics:
                <ol>
                    <li>
                    Client Rights and Responsibilitie
                    </li>
                    <li>
                    Expectation of Families
                    </li>
                    <li>
                    Client Consent for Services
                    </li>
                    <li>
                    Notices of Privacy Practices
                    </li>
                    <li>
                    Telehealth Consent
                    </li>
                    <li>
                    Legal Request/Court Proceedings
                    </li>
                    <li>
                    Crisis/Safety Plan
                    </li>
                </ol>
                </p>

                <p className='w-750'>
                {`If I need any assistance to read and understand this information, I may request accommodation assistance at any time. Any questions or concerns that I may have will be addressed to the Assessor.`}
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Name</td>
                        <td className='small w-250'> Client D.O.B </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Staff Signature and Credentials</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>








            </div>
        </form>
    )
}

